export const CHARGE_TYPE = {
  FLAT: "FLAT",
  PERCENT: "PERCENT",
};
